import { Example } from '@/entities';
import { ExampleDto } from '@/infrastructure/network/dto';

export const exampleDtoToExample = (exampleDto: ExampleDto): Example => {
	return {
		uuid: exampleDto.uuid,
		firstName: exampleDto.firstName,
		surname: exampleDto.surname,
		dob: new Date(exampleDto.dob)
	};
};
